// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/batamp/" + chunkId + "." + {"109":"53f7f7e675371c7bbe6f","234":"eb1ca93d5884eb701fcd","239":"27af907f0b9728c6948a","508":"0a7f33217966a6632aa6","765":"6b2959163df31bd81b1e","837":"4bb62ba088b3d67d218e"}[chunkId] + ".js";
};